import { copies } from '@reveni-io/reveni-ui'

import { storeConnectionError } from './constants'
import { getCustomReason } from './helpers'

export const titleReason = customReasons => {
  return {
    default: lang => {
      return getCustomReason(customReasons?.[lang], 'order_not_found', 'title') || copies[lang].errors.default.title
    },
    external_returns: lang => {
      return (
        getCustomReason(customReasons?.[lang], 'has_external_returns', 'title') ||
        copies[lang].errors.externalReturns.title
      )
    },
    cancelled: lang => {
      return getCustomReason(customReasons?.[lang], 'order_cancelled', 'title') || copies[lang].errors.cancelled.title
    },
    region_not_allowed: lang => {
      return (
        getCustomReason(customReasons?.[lang], 'order_region_not_allowed', 'title') ||
        copies[lang].errors.regionNotAllowed.title
      )
    },
    disabled_giftcard: lang => {
      return (
        getCustomReason(customReasons?.[lang], 'order_with_giftcard', 'title') ||
        copies[lang].errors.disabledGiftcard.title
      )
    },
    disabled_by_rule: lang => {
      return (
        getCustomReason(customReasons?.[lang], 'disabled_by_rule', 'title') || copies[lang].errors.disabledByRule.title
      )
    },
    disabled_channel: lang => {
      return (
        getCustomReason(customReasons?.[lang], 'order_disabled_channel', 'title') ||
        copies[lang].errors.disabledChannel.title
      )
    },
    pending_payment: lang => {
      return (
        getCustomReason(customReasons?.[lang], 'order_pending_payment', 'title') ||
        copies[lang].errors.pendingPayment.title
      )
    },
    reveni_exchange: lang => {
      return (
        getCustomReason(customReasons?.[lang], 'from_previous_exchange', 'title') ||
        copies[lang].errors.reveniExchange.title
      )
    },
    no_amount: lang => {
      return getCustomReason(customReasons?.[lang], 'order_no_amount', 'title') || copies[lang].errors.noAmount.title
    },
    no_customer: lang => {
      return getCustomReason(customReasons?.[lang], 'no_customer', 'title') || copies[lang].errors?.noCustomer?.title
    },
    no_line_items: lang => {
      return getCustomReason(customReasons?.[lang], 'no_line_items', 'title') || copies[lang].errors.noLineItems.title
    },
    chargeback: lang => {
      return getCustomReason(customReasons?.[lang], 'order_chargeback', 'title') || copies[lang].errors.chargeback.title
    },
    store_connection_error: lang => {
      return storeConnectionError[lang]?.title || storeConnectionError.en.title
    },
  }
}

export const textReason = customReasons => {
  return {
    default: (lang, merchant) => {
      return (
        getCustomReason(customReasons?.[lang], 'order_not_found', 'message') ||
        copies[lang].errors.default.message(merchant)
      )
    },
    external_returns: (lang, merchant) => {
      return (
        getCustomReason(customReasons?.[lang], 'has_external_returns', 'message') ||
        copies[lang].errors.externalReturns.message(merchant)
      )
    },
    cancelled: (lang, merchant) => {
      return (
        getCustomReason(customReasons?.[lang], 'order_cancelled', 'message') ||
        copies[lang].errors.cancelled.message(merchant)
      )
    },
    region_not_allowed: (lang, merchant) => {
      return (
        getCustomReason(customReasons?.[lang], 'order_region_not_allowed', 'message') ||
        copies[lang].errors.regionNotAllowed.message(merchant)
      )
    },
    disabled_giftcard: (lang, merchant) => {
      return (
        getCustomReason(customReasons?.[lang], 'order_with_giftcard', 'message') ||
        copies[lang].errors.disabledGiftcard.message(merchant)
      )
    },
    disabled_by_rule: (lang, merchant) => {
      return (
        getCustomReason(customReasons?.[lang], 'disabled_by_rule', 'message') ||
        copies[lang].errors.disabledByRule.message(merchant)
      )
    },
    disabled_channel: (lang, merchant) => {
      return (
        getCustomReason(customReasons?.[lang], 'order_disabled_channel', 'message') ||
        copies[lang].errors.disabledChannel.message(merchant)
      )
    },
    pending_payment: (lang, merchant) => {
      return (
        getCustomReason(customReasons?.[lang], 'order_pending_payment', 'message') ||
        copies[lang].errors.pendingPayment.message(merchant)
      )
    },
    reveni_exchange: (lang, merchant) => {
      return (
        getCustomReason(customReasons?.[lang], 'from_previous_exchange', 'message') ||
        copies[lang].errors.reveniExchange.message(merchant)
      )
    },
    no_amount: (lang, merchant) => {
      return (
        getCustomReason(customReasons?.[lang], 'order_no_amount', 'message') ||
        copies[lang].errors.noAmount.message(merchant)
      )
    },
    no_customer: (lang, merchant) => {
      return (
        getCustomReason(customReasons?.[lang], 'no_customer', 'message') ||
        copies[lang].errors?.noCustomer?.message(merchant)
      )
    },
    no_line_items: (lang, merchant) => {
      return (
        getCustomReason(customReasons?.[lang], 'no_line_items', 'message') ||
        copies[lang].errors.noLineItems.message(merchant)
      )
    },
    chargeback: (lang, merchant) => {
      return (
        getCustomReason(customReasons?.[lang], 'order_chargeback', 'message') ||
        copies[lang].errors.chargeback.message(merchant)
      )
    },
    store_connection_error: lang => {
      return storeConnectionError[lang]?.message || storeConnectionError.en.message
    },
  }
}
